import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import Img from 'gatsby-image'
import { useStaticQuery, graphql } from 'gatsby'
import Marquee from 'react-fast-marquee'

import SEO from '~/components/seo'
import ProductGrid from '~/components/ProductGrid'
import Blog from '~/components/Blog'
import Button from '~/components/Button'

import ReviewsScroller from '~/components/ReviewsScroller'
import Logos from '~/components/Logos'
import InstagramFeed from '~/components/InstagramFeed'
import Introduction from '~/components/Introduction'

import Wiggle from '~/icons/Wiggle'

import { breakpoints } from '~/utils/styles'

const IndexPage = () => {
  const data = useStaticQuery(
    graphql`
      query {
        desktopHero: file(relativePath: { eq: "desktopHero.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1400) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        mobileHero: file(relativePath: { eq: "mobileHero.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 750) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `
  )

  useEffect(() => {
    const scrollLink = document.querySelector('.js-scroll-down')
    scrollLink.addEventListener('click', () => {
      const headerHeight = document.querySelector('.js-header').offsetHeight
      const offsetTop =
        document.querySelector('#product-grid').offsetTop - headerHeight
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      })
    })
  }, [])

  return (
    <>
      <SEO title="CBD Snack Bars" />
      <div id="feefo-service-review-floating-widgetId"></div>
      <Hero>
        <Wrapper>
          <h1>
            Great tasting <span>CBD</span>
            <br />
            snack bars
          </h1>
          <p>
            Think better with super <strong>healthy</strong> ingredients,
            high-powered <strong>CBD</strong> and natural{' '}
            <strong>nootropics</strong>.
          </p>

          <div>
            <Button
              style={{ maxWidth: 160 }}
              background=""
              className="js-scroll-down"
            >
              Shop Now <span className="bounce">&darr;</span>
            </Button>
          </div>
        </Wrapper>
        <HeroBackground>
          <DesktopImage>
            <Img
              fluid={data.desktopHero.childImageSharp.fluid}
              style={{
                height: '100%',
                position: 'absolute',
                top: '50%',
                width: '100%',
                transform: 'translateY(-50%)',
                right: 0,
              }}
            />
          </DesktopImage>
          <MobileImage>
            <Img
              fluid={data.mobileHero.childImageSharp.fluid}
              style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                left: 0,
              }}
            />
          </MobileImage>
        </HeroBackground>
      </Hero>

      <Introduction />
      <Logos />
      <ReviewsScroller />
      <ProductGrid />
      <InstagramFeed />
      <Blog limit={4} />
    </>
  )
}

export default IndexPage

const MarqueeContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #f09565;
  font-family: 'SohneBreit';
  font-weight: 400;

  font-size: 12px;
  letter-spacing: 2px;
  line-height: 33px;

  span {
    margin: 0 20px;
  }

  @media (max-width: ${breakpoints.s}px) {
    font-size: 10px;
    line-height: 30px;
  }
`

const Hero = styled.div`
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  position: relative;
  display: flex;
  background: #edebe0;
  align-items: center;
  overflow: hidden;
  justify-content: center;
  overflow: hidden;

  h1 {
    font-size: 64px;
    margin: 0;
    margin-top: 106px;
    line-height: 1;
    max-width: 900px;
  }

  p {
    font-size: 28px;
    max-width: 600px;
    line-height: 1.4;
    letter-spacing: 0.5px;
  }

  .bounce {
    animation: bounce 2s infinite;
    position: relative;
    display: inline-block;
  }

  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-3px);
    }
  }

  @media (max-width: ${breakpoints.s}px) {
    h1 {
      font-size: 38px;
      max-width: 300px;
    }

    .circle {
      display: none;
    }

    p {
      font-size: 18px;
      max-width: 180px;
    }
  }
`

const HeroBackground = styled.div`
  width: 100%;
  z-index: 0;
  position: absolute;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  bottom: 0;
  background: #edebdf;
  right: 0;
  height: 100%;
`

const Wrapper = styled.div`
  width: 90%;
  max-width: 1100px;
  position: relative;
  z-index: 1;
  margin: 0 auto;

  p {
    line-height: 1.6;
  }

  @media (max-width: ${breakpoints.s}px) {
    .js-scroll-down {
      margin-bottom: 100px;
    }

    p {
      font-size: 14px;
    }
  }
`

const DesktopImage = styled.div`
  width: 100%;
  height: 100%;

  @media (max-width: ${breakpoints.s}px) {
    display: none;
  }
`

const MobileImage = styled.div`
  width: 100%;
  height: 100%;
  display: none;

  @media (max-width: ${breakpoints.s}px) {
    display: block;
  }
`
